import { useQuery } from '@tanstack/react-query'

import { applicationsApplicationsCredentialsRetrieveOptions } from 'src/api/main'

/**
 * Fetches a single app credential by id. Used on the detail page so it can
 * load directly from URL without hydrating the whole credentials list of
 * the parent app.
 */
export const useWorkspaceAppCredential = (
  applicationId: number,
  credentialId: string
) => {
  const enabled = applicationId > 0 && !!credentialId

  return useQuery({
    ...applicationsApplicationsCredentialsRetrieveOptions({
      path: { application_id: applicationId, id: credentialId }
    }),
    enabled
  })
}
